import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import sanitizeHtml from 'sanitize-html'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import Input from '~/components/Form/Input'
import MaxCountTag from '~/components/UI/MaxCountTag'
import { ProductHeaderSubtitle } from '~/components/UI/ProductHeader/HeaderSubtitle'

import { useProductHeaderProvider } from '~/providers/ProductPageProvider'
import { useStyle } from '~/providers/StyleProvider'

import { CUSTOMIZER, NOTE } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ProductNoteProps {
  className?: string
}

export default function ProductNote({ className }: ProductNoteProps) {
  const t = useTranslate()
  const maxLength = 120
  const signatureMaxLength = 35
  const textareaLabelTextStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Secondary,
  })
  const textareaTextStyle = useStyle({
    textPreset: GlobalTextPreset.Input16Primary,
    color: GlobalThemeColors.Black,
  })

  const { loveNote: noteState } = useProductHeaderProvider()
  const [{ note, signature }, setNote] = noteState

  return (
    <div className={cx(css.ProductNote, className)}>
      <ProductHeaderSubtitle
        className={css.subtitle}
        text={t(CUSTOMIZER.ADD_PRODUCT_NOTE)}
      />
      <label>
        <div className={cx(css.textareaContainer)}>
          <Input
            textarea
            placeholder={t(NOTE.MESSAGE_PLACEHOLDER)}
            value={note}
            maxLength={maxLength}
            onChange={(e) => {
              const value = e.currentTarget.value
              const sanitizedValue = sanitizeHtml(value)
              setNote((prev) => ({ ...prev, note: sanitizedValue }))
            }}
            className={cx(textareaTextStyle, css.textarea)}
            inputClassName={cx(css.textAreaInnerInput, textareaTextStyle)}
          />
          <MaxCountTag
            className={cx(css.maxLengthInfo)}
            maxLength={maxLength}
            currentText={note}
          />
        </div>
      </label>
      <label>
        <div className={cx(css.textareaContainer)}>
          <Input
            value={signature}
            maxLength={signatureMaxLength}
            onChange={(e) => {
              const value = e.currentTarget.value
              const sanitizedValue = sanitizeHtml(value)
              setNote((prev) => ({ ...prev, signature: sanitizedValue }))
            }}
            placeholder={t(NOTE.SIGNATURE_PLACEHOLDER)}
            className={cx(textareaTextStyle)}
            inputClassName={cx(textareaTextStyle)}
          />
        </div>
      </label>
    </div>
  )
}
